// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n        .demo-container {\n            border: 1px solid var(--surface-d);\n        }\n    ", "",{"version":3,"sources":["webpack://./src/app/utilities/text.component.ts"],"names":[],"mappings":";QACQ;YACI,kCAAkC;QACtC","sourcesContent":["\n        .demo-container {\n            border: 1px solid var(--surface-d);\n        }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
